
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_160_107)","stroke":"#fff","stroke-width":"1.875","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.984 4.955h19.08M11.984 16.001h19.08M11.984 27.047h19.08M3.95 7.967a3.012 3.012 0 100-6.025 3.012 3.012 0 000 6.025zM3.95 19.013a3.013 3.013 0 100-6.025 3.013 3.013 0 000 6.025zM3.95 30.06a3.013 3.013 0 100-6.026 3.013 3.013 0 000 6.025z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_160_107"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    